import { styles as commonStyles } from '../../../assets/common.scss';
import { styles } from './template.scss';
import { InputWidthValues } from '../../../ui/gzInput';

export const templateIntegrityMonitorPause = document.createElement('template');

templateIntegrityMonitorPause.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class='wrapper'>

    <gz-title id='integrity-monitor-title' fontSize='16'></gz-title>

    <div class='actions-wrapper'>
      <gz-labeled-content id='integrity-monitor-pause-targets' class='label-mw-250' hasFormLabelWidth labelFontSize='14'>
          <div id='integrity-monitor-pause-targets-value'></div>
      </gz-labeled-content>

      <gz-labeled-content id='integrity-monitor-pause-duration-label' class='label-mw-250' hasFormLabelWidth labelFontSize='14'>
        <gz-time-picker id='integrity-monitor-pause-duration' inputWidth="${InputWidthValues.MEDIUM}"></gz-time-picker>
      </gz-labeled-content>
    </div>

    <div class='bottom-buttons'>
      <gz-button id='save-button'></gz-button>
      <gz-button type='outline' color='secondary' id='cancel-button'></gz-button>
    </div>
  </div>
`;
